module.exports = __webpack_public_path__ + "img/project2.5b5876f7.jpg";